/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from "react";
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

const LISTAR_LINKS_UTEIS = `/dadoscomum/links-uteis/v1?UsuarioAdm=false&PaginaAtual=1&TotalItensRetorno=99999`;
const SESSION_STORAGE_KEY = "links_uteis";

export interface LinkUtil {
  id: string;
  nome: string;
  url: string;
  idsEmpresaVendas365: string[];
  idsRegionais365: string[];
  dataCriacao: string;
  dataAtualizacao: string;
}

const fetchData = async (): Promise<LinkUtil[]> => {
  const response = await instance.get(LISTAR_LINKS_UTEIS);
  const data = response?.data?.data || [];

  // Salva no sessionStorage
  if (typeof window !== "undefined") {
    sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(data));
  }

  return data;
};

const getLinksFromSession = (): LinkUtil[] | null => {
  if (typeof window === "undefined") return null;

  const stored = sessionStorage.getItem(SESSION_STORAGE_KEY);
  if (!stored) return null;

  try {
    return JSON.parse(stored);
  } catch {
    return null;
  }
};

export function useLinksUteis() {
  const linksFromSession = React.useMemo(() => getLinksFromSession(), []);

  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["use_links_uteis"],
    refetchOnWindowFocus: false,
    enabled: !linksFromSession, // Só faz a chamada se não tiver no sessionStorage
    initialData: linksFromSession || undefined,
    staleTime: Infinity, // Os dados nunca ficam stale enquanto estiverem no sessionStorage
  });

  // Retorna os dados do sessionStorage se disponível, senão retorna da query
  // Usa query.data quando disponível para garantir que atualiza quando a query terminar
  const data = React.useMemo(() => {
    if (query.data && query.data.length > 0) {
      return query.data;
    }
    if (linksFromSession && linksFromSession.length > 0) {
      return linksFromSession;
    }
    return [];
  }, [query.data, linksFromSession]);

  return {
    ...query,
    data,
  };
}
